import { useEffect, useMemo, useState } from 'react';

export const useConditions = (ref) => {
  const [state, setState] = useState({ minX: 0, maxX: 0, minY: 0, maxY: 0 });
  const [dialogSize, setDialogSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const resizeObserver = new ResizeObserver(() => {
      setDialogSize({
        height: element.offsetHeight,
        width: element.offsetWidth,
      });
    });

    resizeObserver.observe(element);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  useMemo(() => {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    const minY = -screenHeight + dialogSize.height + 16;
    const maxY = -16;
    const minX = 80;
    const maxX = screenWidth - dialogSize.width - 16;
    console.log('setConditions', { minX, maxX, minY, maxY });
    setState({ minX, maxX, minY, maxY });
  }, [dialogSize]);

  return state;
};
